import type { Rule } from 'antd/lib/form';
import { useTranslation } from 'react-i18next';
import { polishExtendedNameRegex } from 'src/shared/regex';

export const lastNameRule = (): Rule => {
  const { t } = useTranslation();

  return ({
    required: true,
    message: t('Please enter correct last name'),
    pattern: polishExtendedNameRegex,
  });
};
